var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { useGetModuleRecordQuery } from "@/store/api";
import Preview from "../list/preview";
export default function AlertMessage(_a) {
    var alert = _a.alert, _b = _a.isVertical, isVertical = _b === void 0 ? false : _b, removeAlert = _a.removeAlert;
    var params = new URLSearchParams(alert.url_redirect);
    var mod = params.get("module");
    var rec = params.get("record");
    var _c = useState({}), alertRecord = _c[0], setAlertRecord = _c[1];
    var response = useGetModuleRecordQuery({
        moduleName: mod,
        recordId: rec,
    }).data;
    useEffect(function () {
        var data = (response === null || response === void 0 ? void 0 : response.data) || {};
        var recordData = (data === null || data === void 0 ? void 0 : data.record) || {};
        setAlertRecord(recordData);
    }, [response]);
    var _d = useState(false), clicked = _d[0], setClicked = _d[1];
    var handleClick = function (value) {
        setClicked(value);
        removeAlert(alert.id);
    };
    return (_jsx(_Fragment, { children: !isVertical ? (_jsxs("div", __assign({ className: "flex flex-col m-2 border-gray-50 relative" }, { children: [_jsx("span", __assign({ className: "absolute right-0 text-gray-400", onClick: function (e) {
                        removeAlert(alert.id);
                    } }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "ml-2 cursor-pointer text-gray-400 hover:text-gray-600" }) })), _jsxs("div", __assign({ className: "flex flex-row border-b-2 border-gray-300 border-dashed" }, { children: [_jsx("a", __assign({ href: "#", className: "text-blue-400 uppercase border-b-2 mt-[4px]", onClick: function (e) {
                                removeAlert(alert.id, true, alert.url_redirect);
                            } }, { children: alert.target_module })), _jsx(Preview, { record: alertRecord, module: mod, handleClick: handleClick })] })), _jsx("span", { children: alert.name }), _jsx("span", { children: alert.description && alert.description })] }))) : (_jsx("div", __assign({ className: "" }, { children: _jsx("div", __assign({ className: "bg-[var(--colors-widget)] cursor-auto p-2" }, { children: _jsxs("div", __assign({ className: "flex flex-col border-gray-50 relative" }, { children: [_jsx("span", __assign({ className: "absolute right-0 text-gray-400", onClick: function (e) {
                                removeAlert(alert === null || alert === void 0 ? void 0 : alert.id);
                            } }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "ml-2 cursor-pointer text-gray-400 hover:text-gray-600" }) })), _jsxs("div", __assign({ className: "flex flex-row border-b-2 border-gray-300 border-dashed" }, { children: [_jsx("a", __assign({ href: "#", className: "text-blue-400 uppercase pt-[4px]", onClick: function (e) {
                                        removeAlert(alert.id, true, alert.url_redirect);
                                    } }, { children: alert.target_module })), _jsx("span", { children: _jsx(Preview, { record: alertRecord, module: mod, handleClick: handleClick }) })] })), _jsx("span", { children: alert.name }), _jsx("span", { children: alert.description && alert.description })] })) })) }))) }));
}
